// extracted by mini-css-extract-plugin
module.exports = {"repeatLots":"4","natural-stone":"natural_stone_style_natural-stone__3HgO4","natural-stone-content":"natural_stone_style_natural-stone-content__1YR8C"};